import { render, staticRenderFns } from "./ElemScene.vue?vue&type=template&id=3e367e2a&"
import script from "./ElemScene.vue?vue&type=script&lang=js&"
export * from "./ElemScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports